import {isObject} from './isObject';

export function isKeyInObject<K extends string>(
  key: K,
  obj: unknown
): obj is Record<K, unknown> {
  if (!isObject(obj)) {
    return false;
  }
  return key in obj;
}
